import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Webportaldiffrence() {
  return (
    <section className="webportal_diffrence p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Key Distinctions between <span>Web Portals</span> and Websites
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 align-items-center">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h4>Web Portals</h4>
            <ul>
              <li>Users interact dynamically with the data on the page.</li>
              <li>
                Portals can host both open public pages and secure
                login-protected pages.
              </li>
              <li>Provide real-time, highly tailored user experiences.</li>
              <li>
                Offer seamless integration with custom and third-party tools.
              </li>
              <li>Regularly update features and adapt content dynamically.</li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={2}
            lg={2}
            xl={2}
            xxl={2}
            className="my-auto text-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="418"
              fill="none"
              viewBox="0 0 10 418"
            >
              <g filter="url(#filter0_d_1092_6769)">
                <path
                  stroke="#000"
                  strokeDasharray="5 5"
                  strokeLinecap="round"
                  d="M5 1v408"
                ></path>
              </g>
              <defs>
                <filter
                  id="filter0_d_1092_6769"
                  width="9"
                  height="417"
                  x="0.5"
                  y="0.5"
                  colorInterpolationFilters="sRGB"
                  filterUnits="userSpaceOnUse"
                >
                  <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                  ></feFlood>
                  <feColorMatrix
                    in="SourceAlpha"
                    result="hardAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  ></feColorMatrix>
                  <feOffset dy="4"></feOffset>
                  <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                  <feComposite in2="hardAlpha" operator="out"></feComposite>
                  <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                  <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1092_6769"
                  ></feBlend>
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1092_6769"
                    result="shape"
                  ></feBlend>
                </filter>
              </defs>
            </svg>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h4>Websites</h4>
            <ul>
              <li>Present static, read-only informational content.</li>
              <li>Authentication is optional and usually unnecessary.</li>
              <li>Provide real-time, highly tailored user experiences.</li>
              <li>Personalization is general and uniform for all users.</li>
              <li>
                Infrequent integration with other systems such as CRM or ERP.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Webportaldiffrence;
